export default "__VITE_ASSET__Crx6wpKp__"